import { DownlossTypeCode } from '../../quote-or-design-form/rooms/heatLoss/downlossTypeCode';
import { RoomFloorHeatLossDetailsFormModel } from '../../quote-or-design-form/rooms/heatLoss/roomFloorHeatLossDetailsFormModel';

export type RoomFloorHeatLossDetailsResponse = {
  displayIndex: number;
  roomAreaPercentage: number | null;
  downlossTypeCode: DownlossTypeCode;
  temperatureBelowInDegreesCelsius: number | null;
};

export const mapRoomFloorHeatLossDetailsResponseToFormModel = (
  response: RoomFloorHeatLossDetailsResponse,
): RoomFloorHeatLossDetailsFormModel => ({
  roomAreaPercentage: response.roomAreaPercentage?.toString() ?? '',
  downlossTypeCode: response.downlossTypeCode,
  temperatureBelowInDegreesCelsius: response.temperatureBelowInDegreesCelsius?.toString() ?? '',
});
